import axios from 'axios';
import { AdSpace, Order, Provider, Campaign } from '../types';
import { dummyAdSpaces, dummyOrders, dummyProviders, dummyCampaigns, dummyDashboardStats } from '../data/dummyData';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.adroj.in/v1';

const apiClient = axios.create({ baseURL: API_BASE_URL, headers: { 'Content-Type': 'application/json' } });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('adroj_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const delay = (ms = 500) => new Promise(res => setTimeout(res, ms));

export const authAPI = {
  login: async (email: string, _password: string) => {
    await delay();
    if (email === 'admin@adroj.in') return { token:'dummy-admin-token', user:{ id:'admin1', name:'Adroj Admin', email, role:'admin' as const } };
    return { token:'dummy-brand-token', user:{ id:'brand1', name:'TVS Motor Company', email, role:'brand' as const, company:'TVS Motor Company' } };
  },
  register: async (_data: any) => { await delay(800); return { success:true }; },
};

export const spacesAPI = {
  getAll: async (filters?: any): Promise<AdSpace[]> => {
    await delay();
    let r = [...dummyAdSpaces];
    if (filters?.state) r = r.filter(s => s.state === filters.state);
    if (filters?.city) r = r.filter(s => s.city === filters.city);
    if (filters?.mediaType) r = r.filter(s => s.mediaType === filters.mediaType);
    if (filters?.minPrice) r = r.filter(s => s.rentAmount >= filters.minPrice);
    if (filters?.maxPrice) r = r.filter(s => s.rentAmount <= filters.maxPrice);
    return r;
  },
  getById: async (id: string): Promise<AdSpace> => { await delay(); return dummyAdSpaces.find(s => s.id === id) || dummyAdSpaces[0]; },
  approve: async (_id: string) => { await delay(); return { success:true }; },
  reject: async (_id: string) => { await delay(); return { success:true }; },
};

export const ordersAPI = {
  getAll: async (): Promise<Order[]> => { await delay(); return dummyOrders; },
  getById: async (id: string): Promise<Order> => { await delay(); return dummyOrders.find(o => o.id === id) || dummyOrders[0]; },
  create: async (_data: any): Promise<Order> => { await delay(800); return dummyOrders[0]; },
  updateStatus: async (_id: string, _status: string) => { await delay(); return { success:true }; },
};

export const providersAPI = {
  getAll: async (): Promise<Provider[]> => { await delay(); return dummyProviders; },
  approveKYC: async (_id: string) => { await delay(); return { success:true }; },
};

export const campaignsAPI = {
  getAll: async (): Promise<Campaign[]> => { await delay(); return dummyCampaigns; },
};

export const dashboardAPI = {
  getStats: async () => { await delay(); return dummyDashboardStats; },
};

export default apiClient;
